import React from 'react';
import Row from '../../../../components/Row';
import Col from '../../../../components/Col';
import Avatar from 'src/components/Avatar';
import Tenant from 'src/components/Tenant';
import Card from 'src/components/Card';
import SectionHeading from 'src/components/SectionHeading/SectionHeading';
import { variables } from 'src/Tenants';
import { Suite } from 'src/SharedCustomHooks/UseSuiteActions/types';
import './key-handoff-suite-details.scss';

interface KeyHandoffSuiteDetailsProps {
  suiteFormData: Suite;
  primaryHomeOwnerName: string;
  homeOwnerProfileImage: string;
}

interface NamedItem {
  name: string;
}

const formatItemNames = (items: NamedItem[]): string =>
  items.map((item: NamedItem) => item.name).join(', ');

const KeyHandoffSuiteDetails = ({
  suiteFormData,
  primaryHomeOwnerName,
  homeOwnerProfileImage,
}: KeyHandoffSuiteDetailsProps) => {
  const hasParkingStalls: boolean =
    Array.isArray(suiteFormData?.parkingStalls) &&
    suiteFormData.parkingStalls.length > 0;

  const hasStorageLockers: boolean =
    Array.isArray(suiteFormData?.storageLockers) &&
    suiteFormData.storageLockers.length > 0;

  const hasKeyFobs: boolean =
    Array.isArray(suiteFormData?.keyFobs) && suiteFormData.keyFobs.length > 0;

  const hasInstructions: boolean = Boolean(suiteFormData.keyHandOffInstructions);

  return (
    <div className="key-handoff-suite-details">
      <div className="suite-summary-panel">
        <Row mdCenter>
          <Col xs="12" md="4">
            <Tenant
              avatar={
                <Avatar
                  url={homeOwnerProfileImage}
                  size="medium"
                  badge="home-owner"
                />
              }
              headline={primaryHomeOwnerName}
              strapline={variables.homeOwner}
            />
          </Col>
          <Col xs="12" md="4">
            <Card
              title={`${variables.Suite} Address`}
              body={suiteFormData.warrantyAddress}
            />
          </Col>
          <Col xs="12" md="4">
            <Card
              title={`${variables.Suite} Number`}
              body={suiteFormData.number}
            />
          </Col>
        </Row>
      </div>

      <div className="suite-details-panel">
        <Row>
          {hasInstructions && (
            <Col xs="12" md="6">
              <div className="instructions-block">
                <SectionHeading title="Key Pickup Instructions" />
                <div
                  className="instructions-content"
                  dangerouslySetInnerHTML={{
                    __html: suiteFormData.keyHandOffInstructions,
                  }}
                />
              </div>
            </Col>
          )}
          <Col xs="12" md={hasInstructions ? '6' : '12'}>
            <ul className="suite-extras-list">
              {hasParkingStalls && (
                <li className="suite-extras-row">
                  <span className="suite-extras-name">Parking Stalls</span>
                  <span className="suite-extras-value">
                    {formatItemNames(suiteFormData.parkingStalls)}
                  </span>
                </li>
              )}
              {hasStorageLockers && (
                <li className="suite-extras-row">
                  <span className="suite-extras-name">Storage Lockers</span>
                  <span className="suite-extras-value">
                    {formatItemNames(suiteFormData.storageLockers)}
                  </span>
                </li>
              )}
              <li className="suite-extras-row">
                <span className="suite-extras-name">Key Fobs</span>
                <span className="suite-extras-value">
                  {hasKeyFobs
                    ? formatItemNames(suiteFormData.keyFobs)
                    : 'No key fobs.'}
                </span>
              </li>
              <li className="suite-extras-row">
                <span className="suite-extras-name">Number of keys</span>
                <span className="suite-extras-value">
                  {suiteFormData.numberOfKeys}
                </span>
              </li>
            </ul>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default KeyHandoffSuiteDetails;